<template>
  <div>
    <vx-card ref="MainCard" class="pb-3" title="IOT - Station Control">
      <div class="flex flex-wrap-reverse items-center justify-between mb-4">
        <vs-input
          class="w-full md:w-1/3 mr-2 vs-input-no-border vs-input-no-shdow-focus"
          icon-pack="feather"
          icon="icon-search"
          icon-no-border
          placeholder="Search by name or MAC address..."
          autocomplete="off"
          v-model="searchQuery"
        />
        <vs-button class="rounded-lg" color="warning" type="filled" @click="loadRows()" icon-pack="feather" icon="icon-refresh-ccw">Reload</vs-button>
      </div>

      <div ref="gridContainer" class="vx-row vs-con-loading__container" style="min-height: 150px;">
        <div class="vx-col lg:w-1/3 md:w-1/2 w-full mb-4" v-for="tr in filteredRows" :key="tr.deviceId">
          <vx-card class="station-card h-full" @click.native="openDetail(tr)">
            <div class="flex justify-between items-start">
              <div>
                <h5>{{ tr.name || 'Unnamed Station' }}</h5>
                <p class="text-grey">{{ tr.deviceId }}</p>
              </div>
              <vs-chip v-if="tr.twinError" color="danger">Error</vs-chip>
              <vs-chip v-else-if="tr.desiredEnabled != null && !tr.desiredEnabled" color="danger">Disabled</vs-chip>
              <vs-chip v-else :color="tr.status === 'Enabled' ? 'success' : 'grey'">{{ tr.status || 'Unknown' }}</vs-chip>
            </div>
            <h6
              v-if="tr.desiredEnabled != null"
              class="mt-2"
              :class="tr.desiredEnabled ? 'text-success' : 'text-danger'"
            >
              {{ tr.desiredEnabled ? 'Pump Enabled to dispense' : 'Pump Disabled to dispense' }}
            </h6>
            <p v-if="tr.twinError" class="text-danger mt-2">{{ tr.twinError }}</p>
            <template v-else>
              <vs-divider class="my-3" />
              <div class="flex justify-between items-center mt-1">
                <span class="text-grey">Connection</span>
                <vs-chip v-if="tr.connectionState" :color="tr.connectionState === 'Connected' ? 'success' : 'warning'">{{ tr.connectionState }}</vs-chip>
                <span v-else class="text-grey">Unknown</span>
              </div>
              <div class="flex justify-between items-center mt-2">
                <span class="text-grey">Last Activity</span>
                <span>{{ formatDate(tr.lastActivityTime) }}</span>
              </div>
              <div class="flex justify-between items-center mt-2" v-if="tr.desiredEnabled != null">
                <span class="text-grey">Acknowledgment</span>
                <vs-chip :color="ackStatus(tr.acknowledgedCode).color">{{ ackStatus(tr.acknowledgedCode).label }}</vs-chip>
              </div>
            </template>
            <div class="flex justify-end mt-4">
              <vs-button class="rounded-lg" color="primary" type="border" icon-pack="feather" icon="icon-settings" @click.stop="openDetail(tr)">Configure</vs-button>
            </div>
          </vx-card>
        </div>

        <div class="vx-col w-full" v-if="!loadingRows && !filteredRows.length">
          <p class="text-grey text-center p-5">No stations found.</p>
        </div>
      </div>

      <vs-popup :title="detail ? detail.deviceId : 'Device Detail'" :active.sync="popupActive">
        <div v-if="detailLoading" class="text-center p-5">
          <span>Loading device detail...</span>
        </div>
        <div v-else-if="detail">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="w-full text-grey">Status</label>
              <div>
                <vs-chip :color="enableForm.enabled ? 'success' : 'danger'">{{ enableForm.enabled ? 'Enabled' : 'Disabled' }}</vs-chip>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="w-full text-grey">Connection State</label>
              <div>
                <vs-chip :color="detail.connectionState === 'Connected' ? 'success' : 'warning'">{{ detail.connectionState || 'Unknown' }}</vs-chip>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="w-full text-grey">Last Activity</label>
              <div>{{ formatDate(detail.lastActivityTime) }}</div>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2">
              <label class="w-full text-grey">Twin Version</label>
              <div>{{ detail.version }}</div>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2" v-if="selectedRow && selectedRow.desiredEnabled != null">
              <label class="w-full text-grey">Acknowledgment</label>
              <div>
                <vs-chip :color="ackStatus(selectedRow.acknowledgedCode).color">{{ ackStatus(selectedRow.acknowledgedCode).label }}</vs-chip>
                <p v-if="selectedRow.acknowledgedDescription" class="text-grey mt-1" style="font-size: 0.8rem;">{{ selectedRow.acknowledgedDescription }}</p>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2" v-if="firstConnect">
              <label class="w-full text-grey">First Connected</label>
              <div>{{ firstConnect }}</div>
            </div>
          </div>

          <vs-divider />

          <div class="vx-row">
            <div class="vx-col md:w-full w-full mt-2">
              <vs-switch class="rounded-pill" v-model="enableForm.enabled">
                <span slot="on">Enabled</span>
                <span slot="off">Disabled</span>
              </vs-switch>
            </div>
            <div class="vx-col md:w-full w-full mt-4">
              <label class="w-full">Message</label>
              <vs-input class="w-full" v-model="enableForm.message" @input="handleMessageInput" placeholder="Reason / display message" />
            </div>
          </div>

          <div class="vx-row flex flex-wrap items-center mt-5">
            <vs-spacer />
            <div class="vx-col">
              <vs-button class="rounded-lg mr-3" color="success" type="border" @click="saveEnable()">Save</vs-button>
              <vs-button class="rounded-lg mr-3" color="warning" type="border" @click="popupActive = false">Close</vs-button>
            </div>
          </div>
        </div>
      </vs-popup>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "IOTStationConfig",

  data: function () {
    return {
      rows: [],
      loadingRows: false,
      searchQuery: "",
      popupActive: false,
      detail: null,
      detailLoading: false,
      selectedDeviceId: null,
      messageAutoFilled: false,
      enableForm: {
        enabled: true,
        message: "",
      },
    };
  },

  computed: {
    filteredRows: function () {
      var query = (this.searchQuery || "").toLowerCase().trim();
      if (!query) return this.rows;
      return this.rows.filter(function (tr) {
        return (tr.name || "").toLowerCase().indexOf(query) !== -1 ||
          (tr.deviceId || "").toLowerCase().indexOf(query) !== -1;
      });
    },

    selectedRow: function () {
      var self = this;
      return this.rows.filter(function (r) { return r.deviceId === self.selectedDeviceId; })[0] || null;
    },

    firstConnect: function () {
      var reported = this.detail && this.detail.properties && this.detail.properties.reported;
      return (reported && reported.FirstConnect && reported.FirstConnect.value) || "";
    },
  },

  watch: {
    "enableForm.enabled": function (enabled) {
      if (!this.enableForm.message || this.messageAutoFilled) {
        this.enableForm.message = this.defaultMessageFor(enabled);
        this.messageAutoFilled = true;
      }
    },
  },

  mounted: function () {
    this.loadRows();
  },

  methods: {
    defaultMessageFor: function (enabled) {
      return enabled ? "Pump Enabled to dispense" : "Pump Disabled to dispense";
    },

    handleMessageInput: function () {
      this.messageAutoFilled = false;
    },

    formatDate: function (value) {
      if (!value) return "";
      return new Date(value).toLocaleString();
    },

    // Maps the twin's acknowledgment status code (ac) per Azure IoT Hub's
    // writable-property convention - see
    // https://learn.microsoft.com/azure/iot-hub/iot-hub-devguide-device-twins
    ackStatus: function (code) {
      switch (code) {
        case 200: return { label: "Applied", color: "success" };
        case 202: return { label: "Updating", color: "warning" };
        case 203: return { label: "Not Reflecting Desired", color: "danger" };
        case 400: return { label: "Rejected", color: "danger" };
        case 500: return { label: "Error", color: "danger" };
        default: return { label: "Pending", color: "warning" };
      }
    },

    loadRows: function () {
      var self = this;
      self.loadingRows = true;
      self.$vs.loading({ container: self.$refs.gridContainer.$el, scale: 0.6 });
      var onSuccess = function (response) {
        var seen = {};
        self.rows = (response.data || [])
          .map(function (item) {
            return {
              name: item.name != null ? item.name : item.Name,
              deviceId: item.deviceId != null ? item.deviceId : item.DeviceId,
              status: item.status != null ? item.status : item.Status,
              connectionState: item.connectionState != null ? item.connectionState : item.ConnectionState,
              lastActivityTime: item.lastActivityTime != null ? item.lastActivityTime : item.LastActivityTime,
              twinError: item.twinError != null ? item.twinError : item.TwinError,
              desiredEnabled: item.desiredEnabled != null ? item.desiredEnabled : item.DesiredEnabled,
              acknowledgedCode: item.acknowledgedCode != null ? item.acknowledgedCode : item.AcknowledgedCode,
              acknowledgedDescription: item.acknowledgedDescription != null ? item.acknowledgedDescription : item.AcknowledgedDescription,
            };
          })
          .filter(function (tr) {
            if (seen[tr.deviceId]) return false;
            seen[tr.deviceId] = true;
            return true;
          });
      };
      var onFinally = function () {
        self.loadingRows = false;
        self.$vs.loading.close(self.$refs.gridContainer.$el);
      };
      self.$ajaxGet(self, "FamsCommands/GetDeviceTwinList", onSuccess, onFinally);
    },

    openDetail: function (tr) {
      this.selectedDeviceId = tr.deviceId;
      this.detail = null;
      this.detailLoading = true;
      this.popupActive = true;
      this.loadDetail(tr.deviceId);
    },

    loadDetail: function (deviceId) {
      var self = this;
      var onSuccess = function (response) {
        var twin = response.data || {};
        self.detail = twin;
        var desired = (twin.properties && twin.properties.desired && twin.properties.desired.DispEnable) || {};
        var enabled = desired.Enabled !== 0;
        var isKnownDefault = !desired.Message ||
          desired.Message === self.defaultMessageFor(true) ||
          desired.Message === self.defaultMessageFor(false);
        self.messageAutoFilled = isKnownDefault;
        self.enableForm = {
          enabled: enabled,
          message: desired.Message || self.defaultMessageFor(enabled),
        };
      };
      var onFinally = function () { self.detailLoading = false; };
      self.$ajaxGet(self, "FamsCommands/GetDeviceTwinDetail?deviceId=" + encodeURIComponent(deviceId), onSuccess, onFinally);
    },

    saveEnable: function () {
      var self = this;
      var payload = {
        deviceId: this.selectedDeviceId,
        enabled: !!this.enableForm.enabled,
        message: this.enableForm.message || "",
      };
      var onSuccess = function () {
        self.$vs.notify({ title: "Saved", text: "Device twin updated.", color: "success" });
        var row = self.rows.filter(function (r) { return r.deviceId === payload.deviceId; })[0];
        if (row) {
          row.desiredEnabled = payload.enabled;
          row.acknowledgedCode = null;
          row.acknowledgedDescription = null;
        }
        self.popupActive = false;
      };
      self.$ajaxPut(self, "FamsCommands/SetDeviceTwinEnable", payload, onSuccess, function () {});
    },
  },
};
</script>

<style scoped>
.station-card {
  cursor: pointer;
  transition: box-shadow 0.2s ease;
}

.station-card:hover {
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.15);
}
</style>
